import { Link, useParams } from 'react-router-dom';
import { FC, useEffect, useState } from 'react';
import { getTicket } from '../ticket.service';
import { ReduxState, TicketById as ITicketById } from '../../../interfaces';
import { FaArrowRightLong } from 'react-icons/fa6';
import moment from 'jalali-moment';
import { ConfigProvider, Divider, Image, Spin } from 'antd';
import { connect, ConnectedProps } from 'react-redux';
import { Button } from '../../components';
import { AnswerTicketModal } from './answerTicketModal/answerTicketModal.index';
import fa_IR from 'antd/locale/fa_IR';

interface OwnProps { }

type Props = OwnProps & ConnectedProps<typeof connector>;

const TicketById: FC<Props> = (props) => {
    const [loading, setLoading] = useState<boolean>(true);
    const { ticketId } = useParams<{ ticketId: string }>();
    const [ticket, setTicket] = useState<ITicketById>();
    const [answerModalOpen, setAnswerModalOpen] = useState<boolean>(false);

    useEffect(() => {
        ticketId && getTicket(setLoading, ticketId, setTicket);
    }, [ticketId]);

    const onAnswerComplete = () => {
        ticketId && getTicket(setLoading, ticketId, setTicket);
    };

    return (
        <div className={'p-6'}>
            <AnswerTicketModal open={answerModalOpen} setOpen={setAnswerModalOpen} onComplete={onAnswerComplete} />
            <Spin spinning={loading}>
                <div className={'flex flex-col p-6 bg-white rounded-lg border border-primary-20'}>
                    <Link className={'clickable'} to={'/ticket'}>
                        <FaArrowRightLong />
                    </Link>
                    <h4 className={'font-bold text-xl text-darkPurple-100 mt-8 max-lg:mt-6 max-lg:text-base'}>
                        {ticket?.title}
                    </h4>
                    <span className={'text-sm font-medium text-black-60 mt-2 max-lg:text-xs'}>
                        {moment.utc(ticket?.createdOn).locale('fa').local().format('dddd jD jMMMM jYYYY، ساعت HH:mm')}
                    </span>
                    <Divider />
                    {ticket?.ticketMessages.map((message, index) => (
                        <div className={`flex flex-col gap-2 items-start mb-4`} key={index}>
                            <div
                                key={index}
                                className={`flex ${message.isSystemAnswer ? 'flex-row' : 'flex-row-reverse'} w-full`}
                            >
                                <div
                                    className={`${message.isSystemAnswer ? 'bg-white' : 'bg-background'
                                        } flex flex-col p-4 rounded-lg max-w-[70%] max-lg:max-w-full border border-primary-20`}
                                >
                                    <p className="text-base font-medium max-lg:text-sm whitespace-pre-line">{message.text}</p>
                                    {message?.files?.fileByteContent && (
                                        <ConfigProvider locale={fa_IR} direction={'ltr'}>
                                            <Image
                                                src={`data:image/png;base64,${message?.files?.fileByteContent[0]}`}
                                                alt="Ticket Image"
                                                preview={true}
                                                wrapperClassName={
                                                    'self-end mt-6 rounded-lg border border-primary-20 w-20 h-20'
                                                }
                                            />
                                        </ConfigProvider>
                                    )}
                                </div>
                            </div>
                            <span className={`text-xs text-black-60 ${message.isSystemAnswer ? 'ml-auto' : 'mr-auto'}`}>
                                {moment
                                    .utc(message.createdOn)
                                    .locale('fa')
                                    .local()
                                    .format('jD jMMMM jYYYY، ساعت HH:mm')}
                            </span>
                        </div>
                    ))}
                    <Button
                        className={'w-full max-w-64 mx-auto'}
                        type={`${ticket?.state?.id === 3 ? 'text' : 'primary'}`}
                        disabled={ticket?.state?.id === 3}
                        onClick={() => setAnswerModalOpen(true)}
                    >
                        {ticket?.state?.id === 3 ? 'تیکت شما بسته شده است' : 'پیام جدید'}
                    </Button>
                </div>
            </Spin>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(TicketById);
